module.exports = __webpack_public_path__ + "77FXFjRbGzN4aCrSFhlh3oX0hVgzZQUfRDuZrPvH3D8.baa7761b377f62b5ebde.woff2";


//////////////////
// WEBPACK FOOTER
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/assets/fonts/font-google/77FXFjRbGzN4aCrSFhlh3oX0hVgzZQUfRDuZrPvH3D8.woff2
// module id = ../../../../../src/assets/fonts/font-google/77FXFjRbGzN4aCrSFhlh3oX0hVgzZQUfRDuZrPvH3D8.woff2
// module chunks = 40